import React, { useState, useEffect, useCallback } from 'react';
import { collection, query, where, getDocs, orderBy, doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import { ProfileHeader } from '../components/ProfileHeader';
import { ProfileTabs } from '../components/ProfileTabs';

function Profile({ user }) {
  const [isPremium, setIsPremium] = useState(false);
  const [reservations, setReservations] = useState([]);
  const [loading, setLoading] = useState(true);

  const checkPremiumStatus = useCallback(async () => {
    if (!user) return;
    try {
      const userDocRef = doc(db, 'users', user.uid);
      const userDocSnap = await getDoc(userDocRef);
      if (userDocSnap.exists()) {
        setIsPremium(userDocSnap.data().isPremium || false);
      } else {
        setIsPremium(localStorage.getItem(`premium_${user.uid}`) === 'true');
      }
    } catch (error) {
      setIsPremium(localStorage.getItem(`premium_${user.uid}`) === 'true');
    }
  }, [user]);

  const fetchReservations = useCallback(async () => {
    if (!user) return;
    try {
      const q = query(
        collection(db, 'reservations'),
        where('userId', '==', user.uid),
        orderBy('createdAt', 'desc')
      );
      const querySnapshot = await getDocs(q);
      const reservationsData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        date: doc.data().date,
        createdAt: doc.data().createdAt?.toDate ? doc.data().createdAt.toDate() : new Date(doc.data().createdAt)
      }));
      setReservations(reservationsData);
    } catch (error) {
      console.error('Error fetching reservations:', error);
      // Fallback to localStorage
      const localReservations = JSON.parse(localStorage.getItem('reservations') || '[]');
      const userReservations = localReservations.filter(r => r.userId === user.uid);
      setReservations(userReservations);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      checkPremiumStatus();
      fetchReservations();
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  if (loading) {
    return (
      <div className="container mx-auto px-8 py-16 text-center">
        <div className="w-1 h-20 bg-border mx-auto mb-8 animate-pulse"></div>
        <p className="text-muted-foreground">Loading profile...</p>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="container mx-auto px-8 py-16 text-center">
        <div className="w-1 h-20 bg-border mx-auto mb-8"></div>
        <h1 className="serif text-4xl mb-4">Please log in</h1>
        <p className="text-muted-foreground">You need to be logged in to view your profile.</p>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-8 max-w-7xl">
      <ProfileHeader user={user} isPremiumUser={isPremium} />
      <ProfileTabs user={user} reservations={reservations} />
    </div>
  );
}

export default Profile;
